module.exports = __webpack_public_path__ + "static/media/phone-right.e96bb200.svg";